<template>
  <div>
    An error occurred during authentication.
  </div>
</template>

<script>
export default {
  name: 'OidcError',
}
</script>
